import { MappingSchema } from '@warebee/shared/import-converter';
import {
  Field,
  GraphQLLocalDateTime,
  ID,
} from '@warebee/shared/util-backend-only-types';

export class PickingWaveAthena {
  @Field(() => ID)
  id: string;

  @Field(() => ID)
  orderLineRuleId: string;

  @Field(() => GraphQLLocalDateTime, { nullable: true })
  pickByDate?: string;

  @Field(() => ID, { nullable: true })
  deliveryRoute?: string;

  @Field(() => ID, { nullable: true })
  dock?: string;

  @Field(() => ID, { nullable: true })
  stagingArea?: string;

  @Field(() => ID, { nullable: true })
  waveId?: string;

  @Field(() => ID, { nullable: true })
  orderType?: string;
}

export const PICKING_WAVE_SCHEMA: MappingSchema<PickingWaveAthena> = {
  fields: [
    {
      name: 'id',
      type: 'string',
    },
    {
      name: 'orderLineRuleId',
      type: 'string',
    },
    {
      name: 'pickByDate',
      type: 'localDateTime',
      optional: true,
    },
    {
      name: 'deliveryRoute',
      type: 'string',
      optional: true,
    },
    {
      name: 'dock',
      type: 'string',
      optional: true,
    },
    {
      name: 'stagingArea',
      type: 'string',
      optional: true,
    },
    {
      name: 'waveId',
      type: 'string',
      optional: true,
    },
    {
      name: 'orderType',
      type: 'string',
      optional: true,
    },
  ],
};
